export enum PermissionActionEnum {
  FULL = 'FULL',
  VIEW = 'VIEW',
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  COPY = 'COPY',
  SAVE = 'SAVE',
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  ACCEPT = 'ACCEPT',
  CANCEL = 'CANCEL',
  PRINT = 'PRINT',
  ATTACHMENTS = 'ATTACHMENTS',
  FILTER = 'FILTER',
  LOCK = 'LOCK',
  POST = 'POST',
  RETRY_FISCALIZATION = 'RETRY_FISCALIZATION',

  DISCOUNT = 'DISCOUNT',
  PRICE_CHANGE = 'PRICE_CHANGE',
  PRICE_CHANGE_SERVICE = 'PRICE_CHANGE_SERVICE',
  PROMENI_REDOSLED = 'PROMENI_REDOSLED',
  PROMENI_LOKACIJU = 'PROMENI_LOKACIJU',
  PLAN_OPERACIJE = 'PLAN_OPERACIJE',
  RELOKACIJA_RN = 'RELOKACIJA_RN',
  NAPOMENA = 'NAPOMENA',
  PODELI_SERIJU = 'PODELI_SERIJU',
  GENERISI_OTPAD = 'GENERISI_OTPAD',
  GENERISI_LAB = 'GENERISI_LAB',
  RADNA_LISTA = 'RADNA_LISTA',
  VAGARSKA_POTVRDA = 'VAGARSKA_POTVRDA',
}
